import { styled } from "styled-system/jsx";

import { typography } from "@revolt/ui";

export const ToolDropZone = styled("div", {
  base: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "var(--gap-sm)",
    padding: "var(--gap-xl)",
    borderRadius: "var(--borderRadius-lg)",
    border: "2px dashed var(--md-sys-color-outline-variant)",
    background: "var(--md-sys-color-surface-container-low)",
    cursor: "pointer",
    transition: "border-color 0.15s, background 0.15s",
    "&[data-active]": {
      borderColor: "var(--md-sys-color-primary)",
      background: "var(--md-sys-color-surface-container)",
    },
  },
});

export const ToolDropIcon = styled("div", {
  base: {
    display: "flex",
    color: "var(--md-sys-color-on-surface)",
    opacity: 0.9,
  },
});

export const ToolDropTitle = styled("span", {
  base: {
    ...typography.raw({ class: "title", size: "medium" }),
    color: "var(--md-sys-color-on-surface)",
    textAlign: "center",
  },
});

export const ToolDropHint = styled("span", {
  base: {
    ...typography.raw({ class: "body", size: "small" }),
    color: "var(--md-sys-color-on-primary-fixed-variant)",
    textAlign: "center",
  },
});
